import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=04e99a51&scoped=true"
var script = {}
import style0 from "./Menu.vue?vue&type=style&index=0&id=04e99a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e99a51",
  null
  
)

export default component.exports